/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from 'react-hook-form'

import ControlledFormControl from './ControlledFormControl'
import { FormControlBaseProps } from './FormControl'
import { FormBaseProps } from './shared'
import Input, { InputProps } from '../Input'
import { clsxm } from '../../lib/clsxm'

type transformProps = {
    input: (value: any) => any
    output: (value: any) => any
}

export type FormInputProps = FormControlBaseProps & InputProps & FormBaseProps & { transform?: transformProps, aside?: React.ReactNode }

const FormInput = (props: FormInputProps) => {
    const {
        control,
        extra,
        asterisk,
        label,
        name,
        className,
        transform,
        rules,
        aside,
        'data-testid': dataTestId = `input-${name}`,
        ...rest
    } = props

    return (
        <ControlledFormControl
            control={control}
            extra={extra}
            asterisk={asterisk}
            label={label}
            className={className}
            name={name}
        >
            <Controller
                control={control}
                name={name}
                rules={rules}
                data-testid={dataTestId}
                render={({ field }) => (
                    <>
                        <Input
                            data-testid={dataTestId}
                            className={clsxm('z-10')}
                            {...field}
                            {...rest}
                            {...(transform && {
                                onChange: (e) => field.onChange(transform.output(e)),
                                value: transform.input(field.value)
                            })}
                        />

                        {aside}
                    </>
                )}
            />
        </ControlledFormControl>
    )
}

export default FormInput
